export default __webpack_public_path__ + "static/media/ganado2.6a5a2eae.jpg";